module.exports = __webpack_public_path__ + "img/25_65.ee363dcd.png";